/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

.textfield-select-group {
  .textfield-select-group-tf .MuiInputBase-root {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

    &:not(:hover):not(:active):not(:focus-within) {
      fieldset.MuiOutlinedInput-notchedOutline {
        border-right: none;
      }
    }
  }
  .textfield-select-group-select {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #f3f3f3;
  }
}
